module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMenu/baMenu.scss
// module id = ./src/app/theme/components/baMenu/baMenu.scss
// module chunks = main